import { isEmpty, pick, some } from 'lodash'
import { IPriceConfiguration } from '../../models/Price'
import { IGridPrice } from '../../models/Price/mappers/mapResponseToPriceGrid'
import { IRoom } from '../../models/Room'
import { priceIsOk } from './index'

export const isPricePartiallyFilled = (
  price: IGridPrice,
  room: IRoom,
  config: IPriceConfiguration,
) => {
  // Check adult prices first
  let hasPrice = arr => some(arr, p => priceIsOk(p))
  if (!config.pricePerPerson) {
    hasPrice = arr => priceIsOk(arr[room.roomSize])
  }
  const keys = ['standard', 'weekend', 'long', 'short']
  const hasAnyAdultPrice = Object.values(pick(price, keys)).some(hasPrice)

  if (hasAnyAdultPrice) {
    return true
  }

  if (+room.additionalBeds && !isEmpty(price.extrabed)) {
    const hasExtrabedPrice = Object.values(pick(price.extrabed, keys)).some(p =>
      priceIsOk(p),
    )

    if (hasExtrabedPrice) {
      return true
    }
  }

  if (config.kidsPrice && !isEmpty(price.kids)) {
    const kidIds = config.kids.map(k => +k.id)
    return price.kids
      .filter(k => kidIds.includes(k.kidId))
      .some(k => Object.values(pick(k, keys)).some(p => priceIsOk(p)))
  }

  return false
}
